import React from 'react';

import './style.scss';
import { User } from '../../../../components/atoms';
import GreenLine from '../../../../components/atoms/GreenLine';

const HistoryView = ({ data, send_or_recieve, challengeSentTo, userName }) => {

  data.sort((a, b) =>
    a.challenge_from.toLowerCase().localeCompare(b.challenge_from.toLowerCase()),
  );
  return data.length ? (
    // return true ? (
    data.length === 1 && data[0].challenge_from === userName ? (
      // false ? (
      <span className='fallback-text'>Challenge history not found.</span>
    ) : (
      <div className='card_hist history'>
        <ul>
          {data.map((itm, index) => {
            return (
              <li key={index}>
                <User
                  name={itm.accept_from}
                  percentage={parseInt(itm.accept_score)}
                  isWinner={
                    parseInt(itm.accept_score) > parseInt(itm.challenge_score)
                  }
                />
                <GreenLine
                  isDraw={
                    parseInt(itm.accept_score) === parseInt(itm.challenge_score)
                  }
                />
                <User
                  name={itm.challenge_from}
                  percentage={parseInt(itm.challenge_score)}
                  isWinner={
                    parseInt(itm.accept_score) < parseInt(itm.challenge_score)
                  }
                  right
                />
              </li>
            );
          })}
        </ul>
      </div>
    )
  ) : (
    <span className='fallback-text'>Challenge history not found.</span>
  );
};

export default HistoryView;
